<template>
  <SAIInput
    v-bind="$attrs"
    :value="parsedDate"
    :disable="disable"
    @input="changeInput"
    @clear="clearInput"
    :placeholder="displayMask"
    :mask="inputMask"
  >
    <template slot="append">
      <QIcon name="eva-calendar-outline" class="cursor-pointer" size="20px">
        <QPopupProxy
          ref="qDateProxy"
          transition-show="scale"
          transition-hide="scale"
        >
          <QDate
            color="primary"
            :value="value || new Date(Date.now())"
            :disable="disable"
            @input="changeDate"
            :options="qDateOptions"
            :mask="parseMask"
          />
        </QPopupProxy>
      </QIcon>
    </template>
  </SAIInput>
</template>

<script>
import { date, QIcon, QPopupProxy, QDate } from 'quasar';
import EnGbLang from 'quasar/lang/en-gb.js';
import { isValidDateStrict } from '../../../utils/dates';

export default {
  name: 'SaiDateInput',
  props: {
    value: {
      type: undefined
    },
    disable: {
      type: Boolean
    },
    parseMask: {
      type: String,
      default: 'YYYY-MM-DDTHH:mm:ss.SSSZ'
    },
    qDateOptions: {
      type: undefined
    }
  },
  data() {
    return {
      displayMask: 'DD/MM/YYYY'
    };
  },
  computed: {
    parsedDate() {
      if (!this.value) {
        return undefined;
      }
      let parsedDate = date.extractDate(
        this.value,
        this.parseMask,
        EnGbLang.date
      );
      return date.formatDate(parsedDate, this.displayMask, EnGbLang.date);
    },
    inputMask() {
      // Replace all alpha numeric characters with a hash symbol
      return this.displayMask.replace(/[a-z0-9]/gi, '#');
    }
  },
  methods: {
    clearInput() {
      this.$refs.qDateProxy.hide();
      this.$emit('input', undefined);
    },
    changeInput(value) {
      this.$refs.qDateProxy.hide();
      if (!value) {
        return this.$emit('input', undefined);
      }
      let sv = value.split('/');
      if (!isValidDateStrict(sv[0], sv[1], sv[2])) {
        return this.$emit('input', undefined);
      }
      let parsedDate = date.extractDate(value, this.displayMask, EnGbLang.date);
      let emitDate = date.formatDate(parsedDate, this.parseMask, EnGbLang.date);
      this.$emit('input', emitDate);
    },
    changeDate(value) {
      this.$refs.qDateProxy.hide();
      this.$emit('input', value);
    }
  },
  components: {
    QIcon,
    QPopupProxy,
    QDate,
    SAIInput: () => import('../sai-input')
  }
};
</script>
